import { useParams, useSearchParams } from 'react-router-dom';

// -----------------------component-----------------------------
// useSearchQuery returns the params and query of the given path

const useSearchQuery = () => {
  const searchParams = useSearchParams()[0];
  const query = {};

  searchParams.forEach((val, key) => {
    query[key] = val;
  });

  const params = useParams();
  Object.keys(params).forEach((key) => {
    query[key] = params[key];
  });

  return query;
};

export default useSearchQuery;
